/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, NetworkListEntryFromJSON, NetworkListEntryToJSON, PageRequestFromJSON, PageRequestToJSON, } from './';
export function PagedResponseOfNetworkListEntryFromJSON(json) {
    return PagedResponseOfNetworkListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfNetworkListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(NetworkListEntryFromJSON)),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious']
    };
}
export function PagedResponseOfNetworkListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nextPage': PageRequestToJSON(value.nextPage),
        'totalElements': value.totalElements,
        'size': value.size,
        'previousPage': PageRequestToJSON(value.previousPage),
        'hasNext': value.hasNext,
        'metaData': MetaDataToJSON(value.metaData),
        'entries': value.entries === undefined ? undefined : (value.entries.map(NetworkListEntryToJSON)),
        'numberOfElements': value.numberOfElements,
        'page': value.page,
        'hasPrevious': value.hasPrevious
    };
}
